'use client';

import { createClient } from '@/lib/supabase/client';

export type AuditEventCategory = 'access' | 'finance' | 'message' | 'approval' | 'auth' | 'data';
export type AuditSeverity = 'info' | 'warning' | 'critical';

export interface AuditEventPayload {
  eventCategory: AuditEventCategory;
  eventAction: string;
  resourceType?: string;
  resourceId?: string;
  description?: string;
  metadata?: Record<string, unknown>;
  severity?: AuditSeverity;
}

/**
 * Logs an audit event to the audit_logs table.
 * Silently fails — never blocks the calling operation.
 */
export async function logAuditEvent(payload: AuditEventPayload): Promise<void> {
  try {
    const supabase = createClient();
    const {
      data: { user },
    } = await supabase.auth.getUser();

    if (!user) return;

    const role: string = user.user_metadata?.role || 'unknown';

    await supabase.from('audit_logs').insert({
      actor_id: user.id,
      actor_email: user.email ?? null,
      actor_role: role,
      event_category: payload.eventCategory,
      event_action: payload.eventAction,
      resource_type: payload.resourceType ?? null,
      resource_id: payload.resourceId ?? null,
      description: payload.description ?? null,
      metadata: payload.metadata ?? {},
      severity: payload.severity ?? 'info',
    });
  } catch {
    // Audit logging must never break the calling feature
  }
}
